/* Copyright (c) 2018 Scaper */

import { Dispatch } from "redoodle";
import { UserInfo } from "@firebase/auth-types";
import * as React from "react";
import { Collections } from "../../functions/src/api/firestoreCollections";
import { SET_USER_INFO, SET_USER_PHONE_NUMBER } from "../app/userReducer";
import { IUserPhoneNumberDocument } from "../app/userState";
import { Logger } from "../utils/logger";
import { AuthType, FirestoreType, FunctionsType } from "./api";

export class UserService {
    constructor(
        private dispatch: Dispatch,
        private auth: AuthType,
        private firestore: FirestoreType,
        private functions: FunctionsType,
    ) {
        const maybeCurrentUser = this.auth().currentUser;
        if (maybeCurrentUser != null) {
            dispatch(SET_USER_INFO.create({ userInfo: maybeCurrentUser }));
        }

        this.auth().onAuthStateChanged((user) => {
            const userInfo = user != null ? user : false;
            dispatch(SET_USER_INFO.create({ userInfo }));
        });
    }

    public confirmPhoneNumber = (verificationPin: string) => {
        const confirmPhoneNumber = this.functions().httpsCallable("confirmPhoneNumber");
        return confirmPhoneNumber(verificationPin).catch((reason) => {
            Logger.error(`Failed to verify with PIN ${verificationPin}.`, reason);
            return Promise.reject(reason);
        });
    };

    public setPhoneNumber = (proposedPhoneNumber: string) => {
        const setPhoneNumber = this.functions().httpsCallable("setPhoneNumber");
        return setPhoneNumber(proposedPhoneNumber).catch((reason) => {
            Logger.error(`Failed to propose phone number ${proposedPhoneNumber}.`, reason);
            return Promise.reject(reason);
        });
    };

    public subscribeToPhoneNumber = (userInfo: UserInfo) => {
        const { uid } = userInfo;
        return this.firestore().collection(Collections.USER_PHONE_NUMBERS).doc(uid).onSnapshot((doc) => {
            const maybePhoneNumberDocument = doc.data() as IUserPhoneNumberDocument | undefined;
            const phoneNumberDocument = maybePhoneNumberDocument != null ? maybePhoneNumberDocument : false;
            this.dispatch(SET_USER_PHONE_NUMBER.create({ phoneNumberDocument }))
        });
    };

    public signOut = (event: React.MouseEvent<HTMLAnchorElement>) => {
        // TODO remove
        event.preventDefault();
        event.stopPropagation();
        this.auth().signOut();
    };
}
